import { styled } from '@mui/material/styles';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

export const RootContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  marginTop: '30px',
  justifyContent: 'space-between',
});

export const StyledTitle = styled(Typography)({
  fontWeight: 600,
  fontSize: '1.5rem',
  marginBottom: '10px',
});

export const StyledQuestion = styled(Typography)({
  marginBottom: '10px',
  color: '#1D6FBB',
  fontWeight: 600,
});

export const SupportButton = styled(Button)({
  marginRight: '10px',
  background: '#1D6FBB',
  color: '#FFFFFF',
  textTransform: 'none',
});

export const NewTicketButton = styled(Button)({
  textTransform: 'none',
  background: 'transparent',
  color: '#1D6FBB',
  border: '1px solid #1D6FBB',
  boxShadow: 'none',
});
